<template lang="pug">
	.ion-page
		ion-header(translucent) 
			ion-img(class="eroro" :src="require('../assets/img/logo-levantek-350.png') " )
		ion-content
			ion-grid()
				form()
					ion-list(lines="none")
						ion-col
							ion-item
								ion-label.input-login(position="floating" ) Usuario:
								ion-input(name="usr" type="email" @ionFocus="addClassHeader();")
						ion-col
							ion-item
								ion-label(position="floating") Contraseña:
								ion-input(name="pass" type="password")
						ion-col
							ion-button(expand="full" @click="checkLogin()" ) INICIAR SESIÓN 
</template>
<style lang="scss" scoped>
	ion-header{
		border: 0px !important;
		border-bottom-color: transparent !important;
		background-image: none !important;
		border-bottom: none !important;
		padding: 20px;
		margin-bottom: 25%;
		transition: all 1s ;
	}
	ion-header.hide-header ion-img{
		height: 70px;
		padding-top:5px; 
		padding-bottom:5px;
		transition: all 1s;
	}
	ion-header ion-img{
		transition: height 1s ease;
 
	}
	ion-header.hide-header ion-img img{max-height: 60px;}
	ion-header.hide-header {
    margin-bottom: 0;
	}
</style>
<script>
	// import Push from "push.js"
	import firebase from 'firebase/app'
	import firebaseA from '../config'
	
	const db  = firebaseA.db;
	import 'firebase/auth';
	
	export default {
		name: "Login",
		// components: { ZipSearch, ZipInfo, ClearInfo },
		data() {
			return {
				publicPath: process.env.BASE_URL,
				info: null,
				re:{},
				roldetails:{},
			};
		},
		firestore: {
			roldetails: db.collection('roles'),
		},
		methods: {
			addClassHeader(){
				let $e = document.querySelector("ion-header");
				$e.classList.add("hide-header");

			},
			createUser () {
				let $e = document.querySelector("[name='usr']").value;
				let $pass = document.querySelector("[name='pass']").value;
				firebase.auth().signInWithEmailAndPassword($e, $pass).then(() => {
          this.$router.replace('/solicitudes')
        }).catch((err) => {
          alert(err.message)
				})
			}, 
			checkLogin () {
				// let psu = Push.create("Examplee...");
				// return;
				let $e = document.querySelector("[name='usr']").value;
				let $pass = document.querySelector("[name='pass']").value;
				firebase.auth().signInWithEmailAndPassword($e, $pass).then( () => {
				if (firebase.auth().currentUser !== null) 
					this.getUserDetalle(firebase.auth().currentUser.uid);
					console.log("lalalalalal")
          // this.$router.replace('/solicitudes-admin')
        }).catch((err) => {
          this.showAlert(err.message)
				})
			}, 
			reRedirect() {
				this.$router.replace('/solicitudes');
				// if(  this.re.rol == "1ib87WwHClPfwbCJS8BB") // Operaciones ROL
				// 	this.$router.replace('/solicitudes')
				// else if( this.re.rol == "jcwXkDPT9SzhJJd179Sr") // USR GRAL ROL
				// 	this.$router.replace('/solicitudes')
				// else
				// 	this.$router.replace('/solicitudes-admin')
			},
			getUserDetalle(_uuid){
				let _self = this;
				db.collection('user_detalles')
				.where('uuid', '==', _uuid)
				.get()
					.then(function(querySnapshot) {
						querySnapshot.forEach(function(doc) {
						// doc.data() is never undefined for query doc snapshots
							// _self.getAcceso(re.rol);
							_self.re     = doc.data();
							_self.re.id  = doc.id;

							_self.$storage.set("user-info",_self.re);
							_self.reRedirect();
						});
					})
					.catch(function(error) {
						console.log("Error getting documents: ", error);
					});
			},
			getAcceso(_rolID) {
				db.collection('roles')
				.doc(_rolID)
				.get()
					.then(function(querySnapshot) {
						querySnapshot.forEach(function(doc) {
						// doc.data() is never undefined for query doc snapshots
						console.log(doc.id, " => ", doc.data());
						});
					})
					.catch(function(error) {
						console.log("Error getting documents: ", error);
					});
			},
			clearInfo() {
				this.info = null;
			},
			showAlert(msg) {
				return this.$ionic.alertController
					.create({
						header: "Error",
						message: msg,
						buttons: ["Aceptar"]
					})
					.then(a => a.present());
			},

		},
		mounted(){
		},
		created() {

		}
	};
</script>